import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NationalDataAuthType } from "@utils/Constants";

interface DataSlice {
  authRequested: boolean;

  nhisAuthInfo: {
    cookieJarJSON: Optional<JSON>;
    additionalData: any;
    authToken: Optional<string>;
  };

  analyzedData: any;
}

const initialState = (): DataSlice => {
  return {
    authRequested: false,

    nhisAuthInfo: {
      cookieJarJSON: null,
      additionalData: null,
      authToken: null,
    },

    analyzedData: null,
  };
};

export type DoAuthActionType = PayloadAction<{
  onSuccess: (param: any) => any;
  onError: (e: Error) => any;
  authType: NationalDataAuthType;
  userInfo: {
    name: string;
    phone: string;
    birthday: string;
  };
}>;

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setNHISAuthInfo: (
      state,
      action: PayloadAction<{
        cookieJarJSON: Optional<JSON>;
        additionalData: any;
        authToken: Optional<string>;
      }>
    ) => {
      state.nhisAuthInfo.cookieJarJSON = action.payload.cookieJarJSON;
      state.nhisAuthInfo.additionalData = action.payload.additionalData;
      state.nhisAuthInfo.authToken = action.payload.authToken;
    },
    clearAuthInfo: (state) => {
      state.authRequested = false;
      state.nhisAuthInfo = {
        cookieJarJSON: null,
        additionalData: null,
        authToken: null,
      };
    },
    setAnalyzedData: (state, action) => {
      state.analyzedData = action.payload;
    },
    startAuth: (state, _action: DoAuthActionType) => {
      state.authRequested = true;
    },
    afterAuth: (_, _action: DoAuthActionType) => {},
  },
});

export const {
  setNHISAuthInfo,
  clearAuthInfo,
  setAnalyzedData,
  startAuth,
  afterAuth,
} = dataSlice.actions;

export default dataSlice.reducer;
